/**
 * @file EventReportTypesView.jsx
 * @author Daniel Aguirre
 * @description Event Report Types View Page
 */

// Dependencies
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import ListItem from 'components/ListItem';
import { getEventIcon } from 'pages/PatientEvents/helper';

function EventReportTypesView({ patientEventActions, actions }) {
  const { t: translate } = useTranslation();
  const [eventTypes, setEventTypes] = useState([]);

  const setData = (_, resp) => {
    setEventTypes(resp.data);
  };

  useEffect(() => {
    const { getEventTypesArray } = patientEventActions;
    const data = { paged: false, limit: 10, page: 0 };
    getEventTypesArray(data, setData);
  }, []);

  const handleOnClick = (eventType) => {
    const { setPatientEventType } = actions;
    setPatientEventType(eventType);
  };

  return (
    <div className="p-5 text-baxterGray">
      <h1 className="mb-5" style={{ fontSize: 20 }}>
        {translate('patientEvents.eventReports')}
      </h1>
      <section>
        <p className="mb-5" style={{ fontSize: 18 }}>
          {translate('patientEvents.description')}
        </p>
        {eventTypes.map((eventType, index) => (
          <ListItem
            key={index}
            onClick={() => handleOnClick(eventType)}
            icon={getEventIcon(eventType.id_event_type)}
            body={
              <span className="font-bold" style={{ fontSize: 14 }}>
                {translate(`patientEvents.${eventType.title}`)}
              </span>
            }
            link={`/main/events/form`}
          />
        ))}
      </section>
    </div>
  );
}

/**
 * Component definition of proptypes.
 */
EventReportTypesView.propTypes = {
  actions: PropTypes.shape({
    setPatientEventType: PropTypes.func.isRequired
  }).isRequired,
  patientEventActions: PropTypes.shape({
    getEventTypesArray: PropTypes.func.isRequired
  }).isRequired
};
export default EventReportTypesView;
